import {Controller} from "@hotwired/stimulus"
import TomSelect from "tom-select";

export class EligiblePlayersController extends Controller {
    static values = {
        selected: Object
    }

    connect() {
        console.log(this.selectedValue)
        this.tomSelect = new TomSelect(this.element, {
            preload: false,
            valueField: "id",
            searchField: ["licence_number", "name"],
            sortField: ["name"],
            options: [this.selectedValue],
            items: [this.selectedValue.id],
            maxOptions: null,
            onDropdownClose: () => {
                this.tomSelect.clearOptions();
            },
            load: async (query, callback) => {
                if (this.tomSelect.loading > 1) {
                    callback()
                    return
                }

                if (query === undefined) {
                    callback()
                    return
                }

                const response = await fetch(`/players/eligible?q=${query}`)
                if (!response.ok) {
                    callback()
                    return
                }
                callback(await response.json())
            },
            render: {
                option: (data, escape) => {
                    return `<div class="row">
                                <div class="col-auto">${escape(data.licence_number)}</div>
                                <div class="col">${escape(data.name)}</div>
                            </div>`
                },
                item: (data, escape) => {
                    return `<div class="row">
                                <div class="col-auto">${escape(data.licence_number)}</div>
                                <div class="col">${escape(data.name)}</div>
                            </div>`
                },
                no_results: function (data, escape) {
                    return '<div class="no-results">Spieler nicht gefunden</div>';
                },
            },
        })
    }

    disconnect() {
        this.tomSelect.destroy()
    }
}
